import React from 'react';
import PropTypes from 'prop-types';

/**
 * 파트너 쿠폰 받기후 노출 토스트
 */
function PartnerBurdenToast({ resultMsg }) {
  return (
    <div className="toast coupon">
      <p className="text">{resultMsg}</p>
    </div>
  );
}

PartnerBurdenToast.propTypes = {
  resultMsg: PropTypes.string,
};

export default PartnerBurdenToast;
